var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOctogone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 744.88,
    height: 744.886,
    viewBox: "0 0 744.88 744.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1162",
    "data-name": "Trac\\xE9 1162",
    d: "M188.325,0,0,188.325V454.669L188.325,643H454.669L642.994,454.669V188.325L454.669,0Z",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 111.655, 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctogone);
export default __webpack_public_path__ + "static/media/octogone.b81f273421b39b652a9f5fe683737b61.svg";
export { ForwardRef as ReactComponent };